import it from '@/i18n/it';
import en from '@/i18n/en';
import es from '@/i18n/es';
import de from '@/i18n/de';
import fr from '@/i18n/fr';

export default function getTranslations() {
    return {
        it,
        en,
        es,
        de,
        fr,
    };
}
